<template>
  <h3 class="pb5">Rapport autoexclusion détaillé - rencontres finales (CDX_0064)</h3>
  <CritereRechercheAutoexclusion ref="critereRechercheAutoexclusion"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheAutoexclusion from "@/components/rapports/Rechercher/CritereRechercheAutoexclusion.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersAutoexclusionDetailleRencontresFinales",
  components: {CritereRechercheAutoexclusion, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Autoexclusion");
    this.isRechercheDataLoading = true;
    this.$store.dispatch("dossier/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
          this.isRechercheDataLoading = false;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheAutoexclusion.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheAutoexclusion.getCriteresRecherche();
      criteresRecherche.titre = "DossiersAutoexclusionDetailleRencontresFinales";
      criteresRecherche.nomRapport = "autoexclusion.AutoexclusionDetailleRencontresFinalesDossierGenerateurRapport_CDX_0064";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>